import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { AddChat, AttachmentMD5Request, AttachmentProcessingDetails, AttachmentProcessingResponse, ChatRequest, ChatResponse, DeleteDocumentDto, ExtractedMSGDOCX, GetDocumentDto, QuestionResponse, RenameChatDto, SharedChatAddDto, CombinedChatDetails, UploadResponse, UrlUploadRequest, UserDropdownData, SharedChatDeleteDto } from 'src/app/core/models/rig-model/file-upload';
import { AttachmentDetails, ChatHistoryDetail, OtherMonthChat, UpdateExtractedRigFile, UserChatDetail } from 'src/app/core/models/rig-model/user-chat-detail';

import { UserProfile } from 'src/app/core/models/user';
import { SessionService } from 'src/app/core/services/auth/session.service';
import { RigService } from 'src/app/core/services/rig/rig.service';
import { UserManagementService } from 'src/app/core/services/user-management/user-management.service';
import { Subscription, forkJoin, of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { ToastViewModel } from 'src/app/core/models/view-model';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatAutocomplete, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { FormControl } from '@angular/forms';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { GlobalService } from 'src/app/core/services/global/global.service';





@Component({
  selector: 'app-regulatory-insights-generator',
  templateUrl: './regulatory-insights-generator.component.html',
  styleUrls: ['./regulatory-insights-generator.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class RegulatoryInsightsGeneratorComponent implements OnInit {

  previewVisible: boolean = false;
  dialogue: boolean = false;
  sharedDialog = false;
  suggestQuestion: boolean = false;
  @ViewChild('fileInput')
  fileInput!: ElementRef;
  urlInput: string = ''; // User-entered URL
  pdfContent: any = null; // Initialize to null or an initial value
  isPdf = false;
  isTxt = false;
  isDocx = false;
  docxExtension = "";
  docxContent: string = '';
  docUrl: string = "";
  value: number = 0;
  value1: number = 0;
  isActiveButton: boolean = false;
  value2: number = 0;
  isCardOpen = false;
  userChatList: Array<UserChatDetail>;
  userDetails: UserProfile;
  azureContainername = "";
  currentChatUuid: string = "";
  attachmentList: AttachmentDetails[] = [];
  userChatDetails: ChatHistoryDetail;
  isTyping = false;
  isProcessing = true;
  isProcessed = false;
  isLoading = false;
  isCollapse: boolean = false;
  messagesStream: string[] = [];
  private subscription: Subscription | undefined;
  isReplyLoading = false;
  isProcessingStarted = true;
  showSuggestions = false;
  isDownCollapse: boolean = true;
  isLoadingMenu: boolean = false;
  isLoaderChat: boolean = false;
  toastViewModel: ToastViewModel;



  //For Chat Details Json
  // documentList: DocumentModel[] = [];
  textList: { Name2: string; Link2: string }[] = [];

  docFileName: string = "";

  //For Text File
  docText: string = "";
  docTextName: string = "";
  isDocTextClicked = false;
  isShowToast = false;

  //For Hyperlink
  myUrl: string = "";
  hyperText: string = "";
  hyperLinkList: Array<string> = [];
  uploadHyperLinkList: Array<string> = [];
  isLinkClicked = false;
  isStaticLink = false;
  staticHyperTextView = "";
  documentNameList: string[] = [];
  yesterdayChats: UserChatDetail[] = [];
  todayChats: UserChatDetail[] = [];
  previous7DaysChats: UserChatDetail[] = [];
  previous30DaysChats: UserChatDetail[] = [];
  userList: UserDropdownData[] = [];
  userDD: UserDropdownData[] = [];
  sharedChatUuid: string = "";
  sharedChatList: CombinedChatDetails[] = [];
  isSharedChat: boolean = false;
  isresponseOngoing = false;


  //For PDF
  page: number = 1;
  totalPages: number = 0;
  isLoaded: boolean = false;

  //For Chat message
  messages: ChatResponse[] = [];
  userInput: string = '';
  userFirstName = "";
  userLastName = "";

  //For msg file
  isMsg = false;
  myData: SafeHtml | undefined;
  zoomLevel: number = 1; // Initial zoom level
  documentDetail: GetDocumentDto[] = [];

  //For suggested questions
  suggestedQuestions: Array<string> = [];
  questionResponse: QuestionResponse = new QuestionResponse();
  groupedChats: OtherMonthChat[] = [];
  nonSuccessAttachments: AttachmentProcessingResponse[] = [];

  @ViewChild('userDDInput')
  userDDInput!: ElementRef<HTMLInputElement>;
  @ViewChild('userAutocomplete')
  userAutocomplete!: MatAutocomplete;
  searchUserCntrl: FormControl = new FormControl();
  selectable = true;
  removable = true;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  addOnBlur = true;
  editChatUuid: string | null = null;
  newChatName: string = '';

  constructor(private userService: UserManagementService, private sessionService: SessionService, private sanitizer: DomSanitizer, private rigService: RigService, private ref: ChangeDetectorRef, private _globalService: GlobalService) {
    this.userDetails = new UserProfile();
    this.userChatList = [];
    this.userChatDetails = new ChatHistoryDetail();
    this.documentDetail = [];
    this.toastViewModel = new ToastViewModel();
  }

  async ngOnInit(): Promise<void> {
    this.userDetails = await this.sessionService
      .getLoginUserInfo()
      .toPromise();
    const userName = this.userDetails.fullName;
    const parts = userName.split(' ');
    this.userFirstName = parts[0];
    if (parts.length > 2) {
      this.userLastName = parts[2];
    }
    else {
      this.userLastName = parts[1];
    }
    this.getUserChatList(this.userDetails.externalUserId, () => { });
    this.getSharedChatList();
    this.getAzureContainer();
    this.getUserDropdown();
    this.suggestQuestion = true;
  }

  collapseSidebar() {
    this.isCollapse = !this.isCollapse;
  }

  downCollapse() {
    if (this.suggestedQuestions.length > 0) {
      this.isDownCollapse = !this.isDownCollapse;
    }
  }


  getAzureContainer() {
    let sourceFolderName = "rig";
    this.rigService.getAzureContainerName(sourceFolderName).subscribe((res: any) => {
      this.azureContainername = res.result;
    });
  }

  getUserChatDetails(chat: UserChatDetail, isShared: boolean) {
    if (isShared) {
      this.isSharedChat = true;
    }
    else {
      this.isSharedChat = false;
      this.sharedChatList = this.sharedChatList.map(chat => {
        chat.isActive = false;
        return chat;
      });
    }
    this.isLoadingMenu = true;
    this.isDownCollapse = true;
    setTimeout(() => {
      this.userChatList = this.userChatList.map(chat => {
        chat.isActive = false;
        return chat;
      });
      this.suggestQuestion = false;
      this.documentDetail = [];
      this.suggestedQuestions = [];
      this.messages = [];
      this.userInput = "";
      this.previewVisible = false;
      this.rigService.getUserChatDetails(chat.uuid).subscribe((res: ChatHistoryDetail) => {
        this.previewVisible = false;
        chat.isActive = true;
        this.userChatDetails = res;
        this.isProcessingStarted = false;
        if (res.chatHistory != null) {
          this.messages = [...JSON.parse(this.userChatDetails.chatHistory)];
          this.ref.detectChanges();
        }
        this.currentChatUuid = this.userChatDetails.uuid;
        const dataArray = JSON.parse(this.userChatDetails.attachment);


        this.documentDetail = dataArray?.map((item: any) => {
          const dto = new GetDocumentDto();
          dto.id = item.Id;
          dto.documentName = item.DisplayName;
          dto.containerName = item.AzureContainerName;
          return dto;
        });
        this.isLoadingMenu = false;
      });
    }, 2000);
  }

  getUserChatList(userId: string, callback: () => void): void {
    this.rigService.getUserChatList(userId).subscribe((res: any) => {
      this.userChatList = res;
      setTimeout(() => {
        this.separateChatsByDate();
        callback();
      }, 1000);
    });
  }
  separateChatsByDate(): void {
    // Filter and sort chats by date group in one line
    this.todayChats = this.userChatList
      .filter(chat => chat.date_group === 'Today')
      .sort((a, b) => this.compareDates(b.createdDateTime, a.createdDateTime));

    this.yesterdayChats = this.userChatList
      .filter(chat => chat.date_group === 'Yesterday')
      .sort((a, b) => this.compareDates(b.createdDateTime, a.createdDateTime));

    this.previous7DaysChats = this.userChatList
      .filter(chat => chat.date_group === 'Previous 7 Days')
      .sort((a, b) => this.compareDates(b.createdDateTime, a.createdDateTime));

    this.previous30DaysChats = this.userChatList
      .filter(chat => chat.date_group === 'Previous 30 Days')
      .sort((a, b) => this.compareDates(b.createdDateTime, a.createdDateTime));
  }

  private compareDates(date1: Date | null, date2: Date | null): number {
    const time1 = date1 ? new Date(date1).getTime() : 0;
    const time2 = date2 ? new Date(date2).getTime() : 0;
    return time1 - time2;
  }

  //Chat Messages
  //Start
  sendMessage() {
    if (this.documentDetail.length > 0) {
      if (this.userInput.trim() !== '') {
        this.suggestQuestion = false;
        let chat = new ChatRequest();
        chat.ChatUUID = this.currentChatUuid;
        chat.Question = this.userInput;
        this.messages.unshift({ content: this.userInput, role: "user", source: [] });
        this.messages.unshift({ content: "", role: "assistant", source: [] });
        this.isReplyLoading = true;
        this.userInput = '';
        this.sendChatRequestWithUpdate(chat);
        this._globalService.scrollSmoothToBottom('rigMainChatBox');
      }
    }
  }
  sendSuggestedMessage(message: string) {
    this.suggestQuestion = false;
    let chat = new ChatRequest();
    chat.ChatUUID = this.currentChatUuid;
    chat.Question = message;
    this.messages.unshift({ content: message, role: "user", source: [] });
    this.messages.unshift({ content: "", role: "assistant", source: [] });
    this.isReplyLoading = true;
    this.sendChatRequestWithUpdate(chat);

  }
  sendChatRequestWithUpdate(chat: ChatRequest) {
    this.userService.generateJoseJWT("").subscribe({
      next: (token: any) => {
        this.rigService.chatResponse(token.message, chat).subscribe({
          next: (response) => {
            this.isReplyLoading = false;
            this.isresponseOngoing = true;
            if (response.type === 'text') {
              this.messages[0].content += response.data;
            } else if (response.type === 'json') {
              this.isresponseOngoing = false;
              this.messages[0].role = response.data.role;
              this.messages[0].source = [...response.data.source];
              let chat = new AddChat();
              chat.chatDetails = JSON.stringify(this.messages);
              chat.uuid = this.currentChatUuid;
              this.rigService.addOrUpdateChat(chat).subscribe((res: any) => { });
            }
          },
          error: (error) => {
            console.error('Error:', error);
          },
          complete: () => {
          }
        });
      },
      error: (error) => {
        console.error('JWT error:', error);
      }
    });
  }
  //End


  // Function to open the file input dialog
  openFileInput() {
    this.fileInput.nativeElement.click();
  }

  // For Document file upload
  onFileSelected(event: any) {
    this.isLoadingMenu = true;
    const selectedFile: File = event.target.files[0];
    let requestData = new UpdateExtractedRigFile();
    if (selectedFile) {
      this.docFileName = selectedFile.name; // Get the filename
      this.rigService.uploadRigFile(selectedFile, this.currentChatUuid, '').subscribe(
        (res: ExtractedMSGDOCX) => {
          const fileObj = res;
          if (fileObj.fileType != "msg" && fileObj.fileType != "docx") {
            const dto = new GetDocumentDto();
            dto.id = fileObj.id;
            dto.documentName = fileObj.displayName;
            dto.containerName = fileObj.azureContainerName;
            this.documentDetail.push(dto);
            let chatUuidIndex = this.userChatList.findIndex(a => a.uuid == this.currentChatUuid);
            if (chatUuidIndex > -1) {
              this.userChatList[chatUuidIndex].isActive = true;
              this.ref.detectChanges();
            }
            else {
              this.getUserChatList(this.userDetails.externalUserId, () => {
                if (this.todayChats.length > 0) {
                  this.currentChatUuid = this.todayChats[0].uuid;
                  this.todayChats[0].isActive = true;
                  this.getUserChatDetails(this.todayChats[0], false);
                }
                this.ref.detectChanges();
              });
            }
            this.successAlert("Provided Documents Uploaded Successfully.");
          }
          else {
            this.userService.generateJoseJWT("").subscribe((token: any) => {
              const myData = new UrlUploadRequest();
              myData.AzureContainerName = this.azureContainername;
              myData.ExternalUrl = "";
              myData.AzureFileName = fileObj.azureFileName;
              this.rigService.getUrlOrFileFetchedData(token.message, myData).subscribe((result: UploadResponse) => {
                const attachment = new AttachmentDetails();
                attachment.azureContainerName = this.azureContainername;
                attachment.azureFileName = result.AzureFileName;
                attachment.displayName = result.DisplayName;
                attachment.externalUrl = "";
                attachment.mD5 = result.MD5;
                attachment.globalAccess = false;
                attachment.updatesID = 0;
                attachment.metadata = result.metadata;
                requestData.attachmentDetails.push(attachment);
                requestData.uuid = this.currentChatUuid;

                this.rigService.updateExtractedRigFile(requestData).subscribe((res: ChatHistoryDetail) => {
                  const dataArray = JSON.parse(res.attachment);
                  this.currentChatUuid = res.uuid;
                  let chatUuidIndex = this.userChatList.findIndex(a => a.uuid == this.currentChatUuid);
                  if (chatUuidIndex > -1) {
                    this.userChatList[chatUuidIndex].isActive = true;
                    this.ref.detectChanges();
                  }
                  else {
                    this.getUserChatList(this.userDetails.externalUserId, () => {
                      if (this.todayChats.length > 0) {
                        this.currentChatUuid = this.todayChats[0].uuid;
                        this.todayChats[0].isActive = true;
                      }
                      this.ref.detectChanges();
                    });
                  }
                  this.successAlert("Provided Documents Uploaded Successfully.");
                  this.documentDetail = dataArray.map((item: any) => {
                    const dto = new GetDocumentDto();
                    dto.id = item.Id;
                    dto.documentName = item.DisplayName;
                    dto.containerName = item.AzureContainerName;
                    return dto;
                  });

                });
              });

            });
          }
          this.isProcessingStarted = false;
          this.isLoadingMenu = false;
        },
        (error: any) => {
          console.error('Upload error:', error);
        }
      );
    }
  }

  closeDialog() {
    this.dialogue = false;
  }

  //For Text File Upload from small modal
  createAndUploadFile(): void {

    if (this.isLinkClicked) {

      this.uploadHyperLink();
      this.closeDialog();
    }
    else {
      this.uploadTXTFile();
    }
    // this.isLoadingMenu = false;
  }

  addHyperLink() {
    if (this.hyperText !== "") {
      if (!this.hyperLinkList.includes(this.hyperText)) {
        this.hyperLinkList.push(this.hyperText);
        this.hyperText = "";
      } else {
        this.hyperText = "";
      }
    }
  }

  removeHyperLink(index: number) {
    if (index >= 0 && index < this.hyperLinkList.length) {
      this.hyperLinkList.splice(index, 1);
    }
  }

  //For Hyperlink Upload from another small model
  uploadHyperLink(): void {

    if (this.hyperText !== "" && this.hyperLinkList.length < 1) {
      this.uploadHyperLinkList.push(this.hyperText);
    }
    else if (this.hyperText !== "" && this.hyperLinkList.length > 0) {
      if (!this.hyperLinkList.includes(this.hyperText)) {
        this.addHyperLink();
      }
      this.uploadHyperLinkList = this.hyperLinkList;
    }
    else if (this.hyperText == "" && this.hyperLinkList.length > 0) {
      this.uploadHyperLinkList = this.hyperLinkList;
    }
    this.uploadHyperLinks();
  }
  uploadHyperLinks() {
    this.isLoadingMenu = true;
    let requestData = new UpdateExtractedRigFile();

    if (this.uploadHyperLinkList.length > 0) {

      this.userService.generateJoseJWT("").pipe(
        switchMap((token: any) => {
          return this.getUrlOrFileFetchedMappedData(token.message, this.uploadHyperLinkList, this.rigService);
        })
      ).subscribe((results: any) => {
        requestData.attachmentDetails = results
          .map((result: UploadResponse, index: number) => {
            if (result) {
              const attachment = new AttachmentDetails();
              attachment.azureContainerName = result.AzureContainerName;
              attachment.azureFileName = result.AzureFileName;
              attachment.displayName = result.DisplayName;
              attachment.externalUrl = this.uploadHyperLinkList[index];
              attachment.mD5 = result.MD5;
              attachment.globalAccess = true;
              attachment.updatesID = 0;
              attachment.metadata = JSON.stringify(result.metadata);
              return attachment;
            }
            return null;
          })
          .filter((attachment: AttachmentDetails | null) => attachment !== null);
        requestData.uuid = this.currentChatUuid;

        this.rigService.updateExtractedRigFile(requestData).subscribe((res: ChatHistoryDetail) => {
          const dataArray = JSON.parse(res.attachment);
          this.currentChatUuid = res.uuid;
          let chatUuidIndex = this.userChatList.findIndex(a => a.uuid == this.currentChatUuid);
          if (chatUuidIndex > -1) {
            this.userChatList[chatUuidIndex].isActive = true;
            this.ref.detectChanges();
          }
          else {
            this.getUserChatList(this.userDetails.externalUserId, () => {
              if (this.todayChats.length > 0) {
                this.currentChatUuid = this.todayChats[0].uuid;
                this.todayChats[0].isActive = true;
                this.getUserChatDetails(this.todayChats[0], false);
              }
              this.ref.detectChanges();
            });
          }
          this.isLoadingMenu = false;
          this.successAlert("Provided Documents Uploaded Successfully.");
          this.hyperLinkList = [];
          this.hyperText = "";
          this.uploadHyperLinkList = [];
          this.documentDetail = dataArray.map((item: any) => {
            const dto = new GetDocumentDto();
            dto.id = item.Id;
            dto.documentName = item.DisplayName;
            dto.containerName = item.AzureContainerName;
            return dto;
          });
        });
      });
      this.isProcessingStarted = false;

    }

  }

  openDocument(documentDetails: GetDocumentDto) {
    this.isStaticLink = false;
    this.rigService.getDocument(documentDetails).subscribe((documentBlob: Blob) => {
      const reader = new FileReader();

      reader.onloadend = () => {

        const arrayBuffer = reader.result as ArrayBuffer;
        const uint8Array = new Uint8Array(arrayBuffer);
        const chunkSize = 1024;
        let binaryString = '';
        for (let i = 0; i < uint8Array.length; i += chunkSize) {
          const chunk = uint8Array.subarray(i, i + chunkSize);
          binaryString += String.fromCharCode.apply(null, Array.from(chunk));
        }
        const base64 = btoa(binaryString);

        const fileExtension = documentDetails.documentName.toLowerCase().split('.').pop();
        let contentType = '';

        switch (fileExtension) {
          case 'pdf':
            contentType = 'application/pdf';
            this.isPdf = true;
            this.isTxt = false;
            // this.isCardOpen = true;
            break;
          case 'txt':
            contentType = 'text/plain';
            this.isTxt = true;
            this.isPdf = false;
            // this.isCardOpen = true;
            break;
          default:
            console.error('Unsupported file type:', fileExtension);
            return;
        }
        this.pdfContent = `data:${contentType};base64,${base64}`;
      };
      reader.readAsArrayBuffer(documentBlob);
    });

    this.previewVisible = true;
  }

  documentDialogue() {
    this.dialogue = true
    this.isLinkClicked = false;
    this.isDocTextClicked = true;
  }
  linkDialogue() {
    this.dialogue = true;
    this.isDocTextClicked = false;
    this.isLinkClicked = true;
  }

  //For PDF document viewer
  afterLoadComplete(pdfData: any) {
    this.totalPages = pdfData.numPages;
    this.isLoaded = true;
  }

  nextPage() {
    this.page++;
  }

  prevPage() {
    this.page--;
  }
  onPageChanged(event: any) {
    this.page = event.page;
  }
  closeCard() {
    this.previewVisible = false;
  }
  zoomIn() {
    this.zoomLevel += 0.1;
  }

  zoomOut() {
    this.zoomLevel -= 0.1;
  }
  //End

  uploadTXTFile() {
    this.isLoadingMenu = true;
    if (this.docText && this.docTextName) {
      const blob = new Blob([this.docText], { type: 'text/plain' });
      const textFile = new File([blob], `${this.docTextName}.txt`, { type: 'text/plain' });

      this.rigService.uploadRigFile(textFile, this.currentChatUuid, '').subscribe(
        (response: ExtractedMSGDOCX) => {
          const dto = new GetDocumentDto();
          dto.id = response.id;
          dto.documentName = response.displayName;
          dto.containerName = response.azureContainerName;
          this.documentDetail.push(dto);
          this.dialogue = false;
          let chatUuidIndex = this.userChatList.findIndex(a => a.uuid == this.currentChatUuid);
          if (chatUuidIndex > -1) {
            this.userChatList[chatUuidIndex].isActive = true;
            this.ref.detectChanges();
          }
          else {
            this.getUserChatList(this.userDetails.externalUserId, () => {
              if (this.todayChats.length > 0) {
                this.currentChatUuid = this.todayChats[0].uuid;
                this.todayChats[0].isActive = true;
                this.getUserChatDetails(this.todayChats[0], false);
              }
              this.ref.detectChanges();
            });
          }
          this.successAlert("Document extracted successfully");
          this.docText = "";
          this.docTextName = "";
        },
        (error: any) => {
          // console.error('File upload error:', error);
          this.warningAlert("Document extraction failed");
        }
      );
      this.isProcessingStarted = false;
    }
    else {
      this.warningAlert("Filename or Text missing. Please provide both.")
    }
    this.isLoadingMenu = false;
  }

  //New Chat
  newChat() {
    this.isSharedChat = false;
    this.hyperLinkList = [];
    this.hyperText = "";
    this.uploadHyperLinkList = [];
    this.isTxt = false;
    this.isPdf = false;
    this.previewVisible = false;
    this.suggestedQuestions = [];
    this.userChatList = this.userChatList.map(chat => {
      chat.isActive = false;
      return chat;
    });
    this.userChatDetails = new ChatHistoryDetail();
    this.currentChatUuid = "";
    this.documentDetail = [];
    this.messages = [];
  }

  closeSuggestions(): void {
    this.showSuggestions = false;
  }

  //Attachment Process Work
  startAttachmentProcess() {
    this.isProcessed = true;
    if (this.messages.length <= 0) {
      this.suggestQuestion = true;
    }
    const dataArray = JSON.parse(this.userChatDetails.attachment);
    this.userService.generateJoseJWT("").subscribe((token: any) => {
      this.rigService.attachmentProcessing(token.message, dataArray).subscribe((res: Array<AttachmentProcessingResponse>) => {
        let attachmentResponse = res;
        this.isProcessing = false;
        let attachmentRequest = new AttachmentMD5Request();
        attachmentRequest.attachment = JSON.stringify(attachmentResponse);
        attachmentRequest.uuid = this.currentChatUuid;
        this.rigService.updateMd5InAttachment(attachmentRequest).subscribe((res: any) => {
          const newDataArray = JSON.parse(res.result);
          this.rigService.getContextualQuestions(token.message, newDataArray).subscribe((resQues: QuestionResponse) => {
            this.suggestedQuestions = [...resQues.Questions];
            this.isDownCollapse = false;
            this.ref.detectChanges();
            this.isProcessed = false;
            this.showSuggestions = true;
          }, (error: any) => {
            this.isProcessed = false;
            this.showSuggestions = true;
          });
        });
      });
    });
  }

  removeDocument(item: GetDocumentDto) {
    let documentDetails = new DeleteDocumentDto();
    documentDetails.uuid = this.currentChatUuid;
    documentDetails.AttachmentId = item.id;
    documentDetails.ContainerName = item.containerName;
    documentDetails.DisplayName = item.documentName;
    this.rigService.deleteExistingDocument(documentDetails).subscribe((res: any) => {
      this.documentDetail = this.documentDetail.filter(obj => obj.id !== item.id);
      this.ref.detectChanges();
    });
    this.successAlert("Document Successfully Deleted.");
  }

  copyToClickboard(messages: string): void {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(messages).then(() => {
      }).catch(err => {
        console.error('Could not copy text: ', err);
      });
    }
  }

  successAlert(text: string): void {
    this.toastViewModel.Title = 'Success';
    this.toastViewModel.Type = 'success';
    this.toastViewModel.Message = text;
    this.isShowToast = true;
    setTimeout(() => {
      this.isShowToast = false;
    }, 3000);
  }

  warningAlert(text: string): void {
    this.toastViewModel.Title = 'Warning';
    this.toastViewModel.Type = 'warning';
    this.toastViewModel.Message = text;
    this.isShowToast = true;
    setTimeout(() => {
      this.isShowToast = false;
    }, 3000);
  }

  getUrlOrFileFetchedMappedData(token: string, uploadHyperLinkList: string[], rigService: RigService) {
    const observables = uploadHyperLinkList.map((str: string) => {
      const myData = new UrlUploadRequest();
      myData.AzureContainerName = "oceandata";
      myData.ExternalUrl = str;

      return rigService.getUrlOrFileFetchedData(token, myData).pipe(
        catchError(error => {

          this.warningAlert("Please check the URLs' you provided are valid or not.");

          console.error('Error for', str, ':', error);
          return of(null);
        })
      );
    });
    return forkJoin(observables);
  }

  deleteChat(uuid: string) {
    this.rigService.deleteChat(uuid).subscribe((res: any) => {
      this.successAlert("Chat Successfully Deleted");
      if (uuid == this.currentChatUuid) {
        this.hyperLinkList = [];
        this.hyperText = "";
        this.uploadHyperLinkList = [];
        this.isDownCollapse = true;
        this.documentDetail = [];
        this.suggestedQuestions = [];
        this.messages = [];
        this.userInput = "";
        this.previewVisible = false;
      }
      this.getUserChatList(this.userDetails.externalUserId, () => { });
      this.ref.detectChanges();
    });

  }

  renameChat(chatName: string, chatuuid: string) {
    let newRenameChat = new RenameChatDto();
    newRenameChat.chatName = chatName;
    newRenameChat.uuid = chatuuid;
    newRenameChat.userId = this.userDetails.externalUserId;
    this.rigService.renameChat(newRenameChat).subscribe((res: any) => {
      let result = JSON.parse(res);
    });
  }

  getUserDropdown() {
    this.rigService.userDropdown().subscribe((res: UserDropdownData[]) => {
      this.userList = res
        .filter(item => item.userId !== this.userDetails.externalUserId)
        .sort((a, b) => {
          if (a.displayName.toLowerCase() < b.displayName.toLowerCase()) {
            return -1;
          }
          if (a.displayName.toLowerCase() > b.displayName.toLowerCase()) {
            return 1;
          }
          return 0;
        });
    });
  }

  addUser(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    if ((value || '').trim()) {
      const selectedUser = this.userList.find(user => user.displayName === value.trim());

      if (selectedUser && !this.userDD.some(user => user.userId === selectedUser.userId)) {
        this.userDD.push(selectedUser);
      }
    }

    if (input) {
      input.value = '';
    }

    this.searchUserCntrl.setValue(null);
  }

  removeUser(user: UserDropdownData): void {
    const index = this.userDD.indexOf(user);
    if (index >= 0) {
      this.userDD.splice(index, 1);
    }
  }

  selectedUserEvent(event: MatAutocompleteSelectedEvent): void {
    const selectedUser = this.userList.find(user => user.userId === event.option.value);

    if (selectedUser && !this.userDD.some(user => user.userId === selectedUser.userId)) {
      this.userDD.push(selectedUser);
    }

    this.searchUserCntrl.setValue(null);
  }

  shareChat() {
    if (this.userDD.length > 0) {
      let sharedWith = this.userDD.map(user => user.userId);
      let sharedChat = new SharedChatAddDto();
      sharedChat.sharedWith = sharedWith;
      sharedChat.sharedBy = this.userDetails.externalUserId;
      sharedChat.uuid = this.sharedChatUuid;
      this.rigService.addSharedChat(sharedChat).subscribe((res: any) => {
        this.sharedDialog = false;
        this.userDD = [];
        this.sharedChatUuid = "";
        this.successAlert("Chat is shared Successfully");
      });
    }
    else {
      this.warningAlert("Please select atleast one user to share this chat");
    }
  }
  startShareChat(uuid: string) {
    this.sharedDialog = true;
    this.sharedChatUuid = uuid;
  }
  getSharedChatList() {
    this.rigService.getSharedChat(this.userDetails.externalUserId).subscribe((res:any) => {
      if(res) {
        this.sharedChatList = [...res];
      }
      else{
        this.sharedChatList = [];
      }
    });
  }
  // Method to start editing a chat name
  startEditChat(chat: UserChatDetail): void {
    this.editChatUuid = chat.uuid;
    this.newChatName = chat.chatName;
  }

  // Method to save the chat name
  saveChatName(chat: UserChatDetail): void {
    if (this.newChatName != "" && this.newChatName !== chat.chatName) {
      let newRenameChat = new RenameChatDto();
      newRenameChat.chatName = this.newChatName;
      newRenameChat.uuid = chat.uuid;
      newRenameChat.userId = this.userDetails.externalUserId;
      this.rigService.renameChat(newRenameChat).subscribe((res: any) => {
        this.getUserChatList(this.userDetails.externalUserId, () => {
          if (this.currentChatUuid != "") {
            const chatDetail = this.userChatList.find(detail => detail.uuid === this.currentChatUuid);
            if (chatDetail) {
              chatDetail.isActive = true;
            }
          }
          this.ref.detectChanges();
        });
        this.successAlert("New chat name updated");
      });
    }
    this.editChatUuid = null;
    this.newChatName = "";
  }

  // Method to cancel the editing
  cancelEdit(): void {
    this.editChatUuid = null;
    this.newChatName = "";
  }

  deleteSharedChat(uuid:string, sharedWith:string){
    let deleteShared = new SharedChatDeleteDto();
    deleteShared.uuid = uuid;
    deleteShared.sharedWith = sharedWith;
    this.rigService.deleteSharedChat(deleteShared).subscribe((res:any)=>{
      this.successAlert("Shared Chat Successfully Deleted.");
      if (uuid == this.currentChatUuid) {
        this.hyperLinkList = [];
        this.hyperText = "";
        this.uploadHyperLinkList = [];
        this.isDownCollapse = true;
        this.documentDetail = [];
        this.suggestedQuestions = [];
        this.messages = [];
        this.userInput = "";
        this.previewVisible = false;
      }
      this.getSharedChatList();
      this.ref.detectChanges();
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

}
